/********************************************************************************
 * THEME FILES / ENTRY POINT
 ********************************************************************************/

/********************************************************************************
 * VENDOR FILES (bundled / includes)
 ********************************************************************************/
import '../../source/vendor/bootstrap-5.3.8/dist/js/bootstrap.bundle.min.js';
import { initHourlyPricing } from './stations/hourly-pricing.js';

/********************************************************************************
 * CUSTOM CODE (All site-specific behavior grouped by functional area)
 ********************************************************************************/

/********************************************************************************
 * LAYOUT: Responsive Media/Text Block Reordering + Debounce Utility
 *  - reorderMediaTextIfMediaOnRight: Swaps media & text for specific patterns
 *  - debounce: Generic debounce helper (used for resize performance)
 ********************************************************************************/

//script to reverse order of image and text on .wp-block-media-text elements with the additional class of .has-media-on-the-right that are children of the .media-text-left-right-offset pattern
function reorderMediaTextIfMediaOnRight() {
    if (document.querySelector('.media-text-left-right-offset')) {
        //check if pattern exists
        const wp_block_media_texts = document.querySelectorAll('.wp-block-media-text');

        for (let i = 0; i < wp_block_media_texts.length; i++) {
            if (wp_block_media_texts[i].classList.contains('has-media-on-the-right')) {
                // this is a relevant element that needs to get the image and text content physically swapped.
                // I had a bit of help from ChatGPT with exactly what to do at this stage. Basically accounts for the container class, and both children, and uses insertBefore to swap them. Its explanation:
                // In this case (I am already in an iterative loop), you don’t need a placeholder because you're only swapping two known adjacent elements.
                // insertBefore(media, content) effectively swaps them if they are in order: content first, media second.
                // After the insert, media becomes the first child, and content becomes the second.

                // this is a relevant element that needs to get the image and text content physically swapped.
                // I had a bit of help from ChatGPT with exactly what to do at this stage. Basically accounts for the container class, and both children, and uses insertBefore to swap them. Its explanation:
                // In this case (I am already in an iterative loop), you don’t need a placeholder because you're only swapping two known adjacent elements.
                // insertBefore(media, content) effectively swaps them if they are in order: content first, media second.
                // After the insert, media becomes the first child, and content becomes the second.

                const container = wp_block_media_texts[i];
                const content = container.querySelector('.wp-block-media-text__content');
                const media = container.querySelector('.wp-block-media-text__media');

                // Make sure both elements exist as they should, and initiate swapping the two media elements.
                if (window.innerWidth < 768) {
                    if (container.firstElementChild !== media) {
                        container.insertBefore(media, content);
                    }
                } else {
                    if (container.firstElementChild !== content) {
                        container.insertBefore(content, media);
                    }
                }
            }
        }
    }
}

// Debounce utility -- Copilot helped with this bit of functionality.
function debounce(func, delay) {
    let timeout;
    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, delay);
    };
}

const debouncedResize = debounce(reorderMediaTextIfMediaOnRight, 25); // (LAYOUT) Reorder on resize

// Trigger on load, but only on appropriately small sizes
if (window.innerWidth < 768) {
    reorderMediaTextIfMediaOnRight(); // Initial call, if pageload starts in a mobile size.
}

// Trigger on resize with debounce
window.addEventListener('resize', debouncedResize);

/********************************************************************************
 * NAVIGATION: Desktop & Mobile Menus + Back Button on Locations Page
 *  - initDesktopMenu: Scroll-based show/hide
 *  - initMobileMenu: Toggle mobile menu state
 *  - updateBackBtn: Injects a back button (history navigation)
 ********************************************************************************/

/**
 * Desktop menu functionality.
 */
function initDesktopMenu() {
    var headerMenu = document.querySelector('.site-header');

    window.addEventListener('scroll', function () {
        if (window.scrollY === 0) {
            headerMenu.classList.remove('hide');
            headerMenu.classList.add('show');
        } else {
            headerMenu.classList.add('hide');
            headerMenu.classList.remove('show');
        }
    });
}

/**
 * Mobile menu functionality.
 */
function initMobileMenu() {
    var mainMenuButton = document.querySelector('.site-header-mobile-toggle');
    var mobileMenu = document.querySelector('.site-header');
    var body = document.body;

    // Remove any existing listeners by replacing the element
    var newMenuButton = mainMenuButton.cloneNode(true);
    mainMenuButton.parentNode.replaceChild(newMenuButton, mainMenuButton);

    // Add fresh event listener
    newMenuButton.addEventListener('click', () => {
        newMenuButton.classList.toggle('active');
        mobileMenu.classList.toggle('site-header-mobile-toggled');
        body.classList.toggle('site-header-mobile-open');
    });
}

// Track current menu state
let currentMenuState = null;

// Handle menu initialization on resize
function handleMenuResize() {
    const isMobile = window.innerWidth < 1200;

    // Only reinitialize if state changed
    if ((isMobile && currentMenuState === 'mobile') || (!isMobile && currentMenuState === 'desktop')) {
        return;
    }

    if (isMobile) {
        currentMenuState = 'mobile';
        initMobileMenu();
    } else {
        currentMenuState = 'desktop';
        initDesktopMenu();
    }
}

// Function to add the back button to the header on the locations page.
function updateBackBtn() {
    const backBtn =
        '<button aria-label="Go back" class="back-btn"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none"><g clip-path="url(#clip0_294_2400)"><path d="M7.15283 10.1437L1.69372 4.68384L0.601122 5.77566L6.06101 11.2348L7.15283 10.1437Z" fill="white"></path><path d="M7.11841 1.43858L6.02736 0.347534L0.567472 5.80742L1.65929 6.89924L7.11841 1.43858Z" fill="white"></path></g><defs><clipPath id="clip0_294_2400"><rect width="7.72152" height="11.5823" fill="white" transform="matrix(-1 0 0 1 7.72156 0)"></rect><rect width="7.72152" height="11.5823" fill="white" transform="matrix(-1 0 0 1 7.72156 0)"></rect></clipPath></defs></svg></button>';
    const header = document.querySelector('header');
    const buttonContainer = header.querySelector('.site-header-back');

    buttonContainer.innerHTML = backBtn;

    // If a user clicks the back button, return to the previous page.
    buttonContainer.addEventListener('click', () => {
        history.go(-1);
    });
}

/********************************************************************************
 * CAROUSELS: Splide Sliders (Partners + Hero + Image Carousel adjustments)
 *  - initSplide: Partners slider (arrows & pagination control)
 *  - addPausePlayBtn (inside DOMContentLoaded): Hero video slide pause/play
 *  - Image carousel arrow offset adjustments
 ********************************************************************************/

// Splide: Our Partners slider on the homepage.
function initSplide() {
    var prevArrow = document.querySelectorAll('.splide-prev');
    var nextArrow = document.querySelectorAll('.splide-next');

    var splide = new Splide('.splide.partner-slider', {
        pagination: false,
        arrows: false,
    }).mount();

    prevArrow.forEach((prev) => {
        prev.addEventListener('click', () => {
            splide.go('-1');
        });
    });

    nextArrow.forEach((next) => {
        next.addEventListener('click', () => {
            splide.go('+1');
        });
    });
}

/********************************************************************************
 * MODAL & FORM: Contact Us Modal Lifecycle + Validation + Thank You State
 *  - initModal: Encapsulates open/close, focus trapping, validation, Braze
 *  - validateForm: Input validation & error handling
 *  - toggleThankYou: Switches between form & success acknowledgment
 ********************************************************************************/

// Contact Us Modal.
function initModal() {
    const modal = document.getElementById('contact-modal');
    const buttons = document.querySelectorAll('.init-contact-modal');
    const emailSubmit = document.querySelector('.init-contact-modal-email');
    const closeModal = modal.querySelector('#close-modal');
    const form = modal.querySelector('#contact-us-form');
    const formMakeSelect = form.querySelector('#autoMake');
    const formModelSelect = form.querySelector('#autoModel');
    const hearAboutUsSelect = form.querySelector('#hearAboutUs');
    const modalEmail = modal.querySelector('form input[id="email"]');
    const submitBtn = modal.querySelector('#submitBtn');
    const responseMsg = modal.querySelector('#responseMessage');
    const inputs = modal.querySelectorAll('input');
    let content = modal.querySelector('.contact-modal__form');
    let thankYou = modal.querySelector('.thank-you');

    // Track last focused element to restore on close
    let lastFocusedElement = null;
    // Focus trap handler reference for add/remove
    let boundTrapHandler = null;

    toggleThankYou(false); // Hide thank you message initially

    // Hides Aria on elements if modal is open
    const pageWrappers = document.querySelectorAll(
        'body > *:not(#contact-modal):not(#dr_cookie_banner_container):not(script):not(style)'
    );

    function setAriaHidden(hidden) {
        pageWrappers.forEach((el) => {
            if (el !== modal) {
                if (hidden) {
                    el.setAttribute('aria-hidden', 'true');
                    // Prevent focusing background content in supporting browsers
                    el.setAttribute('inert', '');
                } else {
                    el.removeAttribute('aria-hidden');
                    el.removeAttribute('inert');
                }
            }
        });
    }

    function getFocusableElements(container) {
        if (!container) return [];
        const selectors = [
            'a[href]:not([tabindex="-1"])',
            'area[href]:not([tabindex="-1"])',
            'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
            'select:not([disabled]):not([tabindex="-1"])',
            'textarea:not([disabled]):not([tabindex="-1"])',
            'button:not([disabled]):not([tabindex="-1"])',
            'iframe:not([tabindex="-1"])',
            '[tabindex]:not([tabindex="-1"])',
            '[contenteditable="true"]:not([tabindex="-1"])',
        ];
        return Array.from(container.querySelectorAll(selectors.join(','))).filter(
            (el) => el.offsetParent !== null || el === document.activeElement
        );
    }

    function trapFocusHandler(e) {
        if (e.key !== 'Tab') return;

        // When thank-you is visible, restrict focusables primarily to it; always include close button
        const tyVisible = thankYou && thankYou.style.display !== 'none';
        let focusables = [];
        if (tyVisible) {
            focusables = getFocusableElements(thankYou);
            if (closeModal) focusables = Array.from(new Set([...focusables, closeModal]));
        } else {
            focusables = getFocusableElements(modal);
        }

        if (focusables.length === 0) return; // nothing to trap

        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        const shift = e.shiftKey;

        if (!shift && active === last) {
            e.preventDefault();
            first.focus();
        } else if (shift && active === first) {
            e.preventDefault();
            last.focus();
        }
    }

    function toggleThankYou(show = true) {
        if (show) {
            content.style.display = 'none';
            thankYou.style.display = 'block';
            const modalFormWrapper = modal.querySelector('.modal-form-wrapper');
            if (modalFormWrapper) {
                modalFormWrapper.style.backgroundColor = '#000';
            }
            // Improve a11y: hide form from AT and focus
            content.setAttribute('aria-hidden', 'true');
            content.setAttribute('inert', '');
            thankYou.removeAttribute('aria-hidden');
            thankYou.removeAttribute('inert');
            // Move focus to a readable element in Thank You (heading), fallback to close button
            const tyHeading = thankYou.querySelector('h2');
            if (tyHeading) {
                tyHeading.setAttribute('tabindex', '-1');
                tyHeading.focus();
            } else if (closeModal) {
                closeModal.focus();
            }
        } else {
            content.style.display = 'block';
            thankYou.style.display = 'none';
            const modalFormWrapper = modal.querySelector('.modal-form-wrapper');
            if (modalFormWrapper) {
                modalFormWrapper.style.backgroundColor = '';
            }
            content.removeAttribute('aria-hidden');
            content.removeAttribute('inert');
            thankYou.setAttribute('aria-hidden', 'true');
            thankYou.setAttribute('inert', '');
        }
    }

    function modalOpen() {
        toggleThankYou(false); // Ensure thank you message is hidden
        hideErrorSpans(modal); // Hide any error messages
        modal.classList.add('active');
        setAriaHidden(true); // Hide background from screen readers
        // Save last focused element and trap focus in modal
        lastFocusedElement = document.activeElement;
        boundTrapHandler = trapFocusHandler.bind(this);
        modal.addEventListener('keydown', boundTrapHandler);
        const firstInput = modal.querySelector('input, button, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstInput) firstInput.focus();
    }

    function modalClose() {
        modal.classList.remove('active');
        setAriaHidden(false); // Restore background to screen readers
        if (modal.getAttribute('location')) {
            modal.removeAttribute('location');
        }
        // Remove focus trap and restore focus
        if (boundTrapHandler) {
            modal.removeEventListener('keydown', boundTrapHandler);
            boundTrapHandler = null;
        }
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus();
        }
    }

    function hideErrorSpans() {
        // Hide all error message spans inside the modal whose id ends with '-error'
        const errorSpans = form.querySelectorAll('[id$="-error"]');
        errorSpans.forEach((span) => {
            span.style.display = 'none';
        });
        form.querySelectorAll('.form-text-input, .form-select-input').forEach((el) => {
            el.classList.remove('error');
            el.setAttribute('aria-invalid', 'false');
        });
        form.querySelectorAll('.contact-us-form__field--invalid').forEach((el) => {
            el.classList.remove('contact-us-form__field--invalid');
        });
    }

    // Reset the submit button on page load
    submitBtn.disabled = false;
    submitBtn.innerHTML = 'Submit';
    responseMsg.innerHTML = '';

    // If the user clicks on a button to open the modal, open it.
    buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            modalOpen();
        });
    });

    // Delegated handler to support dynamically injected buttons (e.g., map station cards)
    document.addEventListener('click', (e) => {
        const dynamicBtn = e.target.closest('.init-contact-modal');
        if (!dynamicBtn) return;
        // Avoid double handling if already bound directly
        if (buttons.length && Array.from(buttons).includes(dynamicBtn)) return;
        e.preventDefault();
        const loc = dynamicBtn.getAttribute('data-location');
        if (loc) {
            try { modal.setAttribute('location', loc); } catch { /* noop */ }
        }
        modalOpen();
    });

    // listen for query params in the URL to trigger the modal
    let urlParams = new URLSearchParams(window.location.search);
    let action = urlParams.get('action');
    if (action && action === 'connect') {
        modalOpen();
    }

    if (emailSubmit) {
        var emailForm = emailSubmit.closest('form');

        emailSubmit.addEventListener('click', (e) => {
            e.preventDefault();
            if (emailForm.elements['email'].value !== '') {
                modalOpen();
                modalEmail.value = emailForm.elements['email'].value;
            }
        });
    }

    // Function to populate the models dropdown based on the selected EV make
    function populateModelsSelector() {
        // Get make/model elements
        // const otherModelRow = document.getElementById('other-make-model-row'); // DIV container for the "Other Make/Model" fields
        const selectedOpt = formMakeSelect.options[formMakeSelect.selectedIndex]; // Selected EV Make OPTION element

        // If no option is selected, exit the function
        if (!selectedOpt) return;

        // Otherwise, parse models from data-models attribute on the OPTION
        let models = [];
        try {
            models = JSON.parse(selectedOpt.getAttribute('data-models') || '[]');
        } catch (e) {
            console.warn('Invalid data-models JSON:', e);
            models = [];
        }

        // Updated the model select
        formModelSelect.innerHTML = '';

        // Add placeholder to the model select element
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = 'Select a ' + selectedOpt.value + ' model';
        formModelSelect.appendChild(placeholder);

        // Add model options to the model select element
        models.forEach((model) => {
            const opt = document.createElement('option');
            opt.value = model;
            opt.textContent = model;
            formModelSelect.appendChild(opt);
        });

        // Disable the models select if there are no valid models to choose from
        const shouldDisable = models.length === 1 && (models[0] === 'Other' || /do not own/i.test(selectedOpt.value));
        formModelSelect.disabled = shouldDisable;

        // If disabled, select the first real option (not placeholder)
        if (shouldDisable && formModelSelect.options.length > 1) {
            formModelSelect.selectedIndex = 1;
        }

        // Toggle the "Other Make/Model" fields visibility if the user has selected "Other" from either the EV make or model dropdown
        toggleOtherFieldsDisplay();
    }

    function clearModelsSelector() {
        // Clear the model select element and reset to placeholder
        formModelSelect.innerHTML = '';

        // Define the placeholder
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = 'Select a model';
        formModelSelect.appendChild(placeholder);

        // Enable the model select
        formModelSelect.disabled = false;
    }

    // Helper function to toggle visibility of the "Other Make/Model" fields on "Connect with Us" form
    function toggleOtherFieldsDisplay() {
        const otherMakeModelRow = document.getElementById('other-make-model-row');
        const autoMakeOther = document.getElementById('autoMakeOther');
        const autoModelOther = document.getElementById('autoModelOther');
        const autoMakeOtherField = autoMakeOther.closest('.contact-us-form__field');

        // Run field normalization on every call
        // Normalize the otherMake, otherModel, and otherHeardAboutUs field settings
        autoMakeOther.value = '';
        autoMakeOther.disabled = false;
        autoMakeOtherField.style.display = '';
        autoModelOther.value = '';

        // Show or hide the "Other Make/Model" fields based on the selected values
        if (formMakeSelect.value === 'Other' && formModelSelect.value === 'Other') {
            otherMakeModelRow.classList.remove('hidden');
            autoMakeOther.focus();
        } else if (formMakeSelect.value !== 'Other' && formModelSelect.value === 'Other') {
            // Hide otherMake since the value is already set in the select field
            // Make is already chosen in the select, so only ask for the model
            otherMakeModelRow.classList.remove('hidden');
            autoMakeOther.disabled = true;
            autoMakeOtherField.style.display = 'none';
            autoModelOther.focus();
        } else {
            // Hide the "Other Make/Model" fields
            otherMakeModelRow.classList.add('hidden');
        }
    }

    // Helper function to toggle visibility of the "Other Heard About Us" field on "Connect with Us" form
    function toggleOtherHeardAboutUsDisplay() {
        const otherHeardAboutUsRow = document.getElementById('other-heard-about-us-row');
        const hearAboutUsOther = document.getElementById('hearAboutUsOther');

        // Normalize the otherHeardAboutUs field settings on every call
        hearAboutUsOther.value = '';
        hearAboutUsOther.disabled = false;

        // Show or hide the "Other Heard About Us" field based on the selected value
        if (hearAboutUsSelect.value === 'Other') {
            otherHeardAboutUsRow.classList.remove('hidden');
            hearAboutUsOther.focus();
        } else {
            otherHeardAboutUsRow.classList.add('hidden');
        }
    }

    function validateForm() {
        let isValid = true;

        // List of all form fields to validate.
        const fields = [
            'firstName',
            'lastName',
            'email',
            'phoneNumber',
            'zipCode',
            'autoMake',
            'autoModel',
            'autoMakeOther',
            'autoModelOther',
            'hearAboutUs',
            'hearAboutUsOther',
        ];
        const optionalFields = ['phoneNumber', 'autoMakeOther', 'autoModelOther', 'hearAboutUsOther'];
        let data = {};

        // Define regex patterns
        const nameRegex = /^[A-Za-z]+(?:[.'’][A-Za-z]+)*\.?(?:(?: +|-)[A-Za-z]+(?:[.'’][A-Za-z]+)*\.?)*\.?$/; // Allows letters, spaces, hyphens, periods, apostrophes, and right single quotation marks
        const emailRegex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
        const zipRegex = /^(?:\d{5}|[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d)$/i;
        const phoneRegex = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;

        responseMsg.classList.remove('hidden');

        // Validate text fields in form
        fields.forEach((field) => {
            const input = form.querySelector(`#${field}`);
            const value = input.value.trim();
            data[field] = value;

            // Reset any previous error styles
            input.classList.remove('error');

            // Empty check. Does not apply to optional fields like phone number and "Other" make/model.
            if (!optionalFields.includes(field) && !value) {
                input.classList.add('error');
                isValid = false;
                return;
            }

            // Additional field-specific validation
            if ((field === 'firstName' || field === 'lastName') && !nameRegex.test(value)) {
                input.classList.add('error');
                isValid = false;
            }

            if (field === 'email' && !emailRegex.test(value)) {
                input.classList.add('error');
                isValid = false;
            }

            if (field === 'phoneNumber' && value && !phoneRegex.test(value)) {
                input.classList.add('error');
                isValid = false;
            }

            if (field === 'zipCode' && !zipRegex.test(value)) {
                input.classList.add('error');
                isValid = false;
            }

            // Check autoMake select field.
            if (field === 'autoMake' && !value) {
                input.classList.add('error');
                isValid = false;
            }

            // Check autoModel select field.
            if (field === 'autoModel' && !value) {
                input.classList.add('error');
                isValid = false;
            }

            // If "Other" is selected for autoMake dropdown, the corresponding text field must be filled
            if (field === 'autoMakeOther' && data.autoMake === 'Other' && !value) {
                console.warn('Auto Make = ' + data.autoMake);
                input.classList.add('error');
                isValid = false;
            }

            // If "Other" is selected for autoodel dropdown, the corresponding text field must be filled
            if (field === 'autoModelOther' && data.autoModel === 'Other' && !value) {
                console.warn('Auto Model = ' + data.autoModel);
                input.classList.add('error');
                isValid = false;
            }

            // If "Other" is selected for hearAboutUs dropdown, the corresponding text field must be filled
            if (field === 'hearAboutUsOther' && data.hearAboutUs === 'Other' && !value) {
                console.warn('Hear About Us = ' + data.hearAboutUs);
                input.classList.add('error');
                isValid = false;
            }
        });

        // Expose each field's state to assistive tech and show its own message
        fields.forEach((field) => {
            const input = form.querySelector(`#${field}`);
            const invalid = input.classList.contains('error');
            const message = document.getElementById(input.getAttribute('aria-describedby'));
            input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
            input.closest('.contact-us-form__field')?.classList.toggle('contact-us-form__field--invalid', invalid);
            if (message) message.style.display = invalid ? 'block' : 'none';
        });

        // If not valid, show error message
        if (!isValid) {
            form.querySelector('[aria-invalid="true"]')?.focus();
            responseMsg.innerHTML = '<div class="error"><p>Required fields are missing or incorrect.</p></div>';
            submitBtn.disabled = false;
            submitBtn.innerHTML = 'Submit';
        }

        return { isValid, data };
    }

    // Attach form submit handler only if form exists, and log for debugging
    if (form) {
        form.addEventListener('submit', function (e) {
            const location = modal.getAttribute('location');

            e.preventDefault();
            // Disable submit button
            submitBtn.disabled = true;
            submitBtn.innerHTML = 'Submitting...';
            // Clear any previous response messages
            responseMsg.innerHTML = '';

            const check = validateForm();

            if (check.isValid) {
                if (window.braze) {
                    // Get the current Braze user
                    const currentUser = braze.getUser();

                    currentUser.setFirstName(`${check.data.firstName}`);
                    currentUser.setLastName(`${check.data.lastName}`);
                    currentUser.setEmail(`${check.data.email}`);
                    currentUser.setPhoneNumber(`${check.data.phoneNumber}`);
                    currentUser.setCustomUserAttribute('zip_code', `${check.data.zipCode}`);
                    // Get autoMake from write-in value if select value is set to "Other"
                    let autoMake = check.data.autoMake === 'Other' ? check.data.autoMakeOther : check.data.autoMake;
                    currentUser.setCustomUserAttribute('auto_make', autoMake);

                    // Get autoModel from write-in value if select value is set to "Other"
                    let autoModel = check.data.autoModel === 'Other' ? check.data.autoModelOther : check.data.autoModel;
                    currentUser.setCustomUserAttribute('auto_model', autoModel);

                    // Get hearAboutUs from write-in value if select value is set to "Other"
                    let hearAboutUs = check.data.hearAboutUs === 'Other' ? check.data.hearAboutUsOther : check.data.hearAboutUs;
                    currentUser.setCustomUserAttribute('hear_about_us', hearAboutUs);

                    // Set signup date
                    currentUser.setCustomUserAttribute('signup_date', new Date());

                    if (location) {
                        // Set notify me map locaiton and Log map-specific custom event
                        currentUser.addToCustomAttributeArray('notify_location', location);
                        currentUser.setCustomUserAttribute('signup_source', 'location_signup');
                        braze.logCustomEvent('signup', { signup_source: 'location_signup' });
                    } else {
                        // Log this as coming from the global form
                        currentUser.setCustomUserAttribute('signup_source', 'sitewide_signup_form');
                        braze.logCustomEvent('signup', { signup_source: 'sitewide_signup_form' });
                    }
                }

                toggleThankYou();

                // Remove location attribute
                if (location) {
                    modal.removeAttribute('location');
                }

                // Reset the form to the default state
                // clearModelsSelector() needs to be run first for toggle functions to hide the "other" fields
                form.reset(); //Step 1: reset form
                clearModelsSelector(); //Step 2: clear model selector of dynamic values
                toggleOtherFieldsDisplay(); //Step 3: hide "other" Make/Model fields
                toggleOtherHeardAboutUsDisplay(); //Step 4: hide "other" Heard About Us field

                // Re-enable the submit button and reset its text
                submitBtn.disabled = false;
                submitBtn.innerHTML = 'Submit';
            } else {
                // Re-enable the submit button if validation fails
                submitBtn.disabled = false;
                submitBtn.innerHTML = 'Submit';
            }
        });
    }

    closeModal.addEventListener('click', () => {
        if (modal.classList.contains('active')) {
            modalClose();
            responseMsg.innerHTML = '';
            inputs.forEach((formInput) => {
                formInput.classList.remove('error');
            });
            hideErrorSpans();
            let divEmailSubmit = document.querySelector('.email-submit');
            if (divEmailSubmit) {
                let emailInput = divEmailSubmit.querySelector('input[type="email"]');
                if (emailInput) {
                    emailInput.value = '';
                }
            }
        }
    });

    // Events to update "Connect With Us" form fields based on user selections
    formMakeSelect.addEventListener('change', populateModelsSelector);
    formModelSelect.addEventListener('change', toggleOtherFieldsDisplay);
    hearAboutUsSelect.addEventListener('change', toggleOtherHeardAboutUsDisplay);

    // Allow ESC key to close the modal for keyboard users
    modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
            e.stopPropagation();
            closeModal.click();
        }
    });
}

/********************************************************************************
 * COOKIES: Basic Cookie Helpers & Consent Banner
 *  - getCookie / setCookie: Simple cookie CRUD utilities
 *  - initCookieNotice: Consent UI + allow/deny handlers + tab toggles
 *  - updateCookieBtn: Responsive label/icon for revoke button
 ********************************************************************************/

// Get the cookie preferences.
getCookie = (name) => {
    let cookieName = name + '=';
    const cookieArray = document.cookie.split(';');

    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }

        if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }

    return null;
};

// Set a cookie with a specific name, value, and expiration date
setCookie = (name, value, days) => {
    let expires = '';

    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires + '; path=/';
};

// Cookie Notice/Request functionality.
function initCookieNotice(consentBanner, button) {
    const btn = button;
    const banner = consentBanner;
    const tabIcons = document.querySelectorAll('.dr-overview-item');
    const denyCookie = document.getElementById('cc-deny-01');
    const allowCookie = document.getElementById('cc-allow-01');

    handleTabClick = (tabIcons) => {
        tabIcons.forEach((tab) => {
            const tabID = tab.dataset.tabid;
            const tabLink = tab.dataset.url;

            tab.addEventListener('click', () => {
                const tabContent = document.getElementById(`dr-tab-${tabID}-details`);
                if (tabContent) {
                    if (tabContent.classList.contains('dr-tab-details-active')) {
                        tabContent.classList.remove('dr-tab-details-active');
                    } else {
                        tabContent.classList.add('dr-tab-details-active');
                    }
                }

                if (tabLink) {
                    window.open(tabLink, '_blank').focus();
                }
            });
        });
    };

    handleCookiePermissions = (banner, button) => {
        document.cookie = 'cookieconsent_status=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'cookieconsent_mode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

        allowCookie.addEventListener('click', () => {
            setCookie('cookieconsent_status', 'allow', 365);
            setCookie('cookieconsent_mode', '["statistic", "marketing", "unclassified"]', 365);
            banner.classList.add('cc-invisible');
            banner.style.display = 'none';
            button.style.display = '';
        });

        denyCookie.addEventListener('click', () => {
            setCookie('cookieconsent_status', 'deny', 365);
            setCookie('cookieconsent_mode', '[]', 365);
            banner.classList.add('cc-invisible');
            banner.style.display = 'none';
            button.style.display = '';
        });
    };

    handleTabClick(tabIcons);
    handleCookiePermissions(banner, btn);
}

function updateCookieBtn() {
    const cookieBtn = document.querySelector('.cc-revoke.cc-bottom');
    if (!cookieBtn) return;

    if (window.innerWidth <= 768) {
        cookieBtn.classList.remove('cc-animate');
        cookieBtn.innerHTML = `<svg role="presentation" version="1.1" id="dr_mobilePreviewCookie" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve">
                <g id="surface1" class="dr_mobilePreviewCookie_fill">
                    <path d="M25,4C13.4,4,4,13.4,4,25s9.4,21,21,21s21-9.4,21-21c0-0.7-0.1-1.3-0.1-1.8c0-0.4-0.2-0.7-0.6-0.8s-0.7-0.1-1,0.1  c-0.6,0.4-1.2,0.6-1.9,0.6c-1.4,0-2.7-0.9-3.2-2.2c-0.1-0.3-0.3-0.5-0.6-0.6c-0.3-0.1-0.6-0.1-0.8,0.1C37,20.7,36,21,35,21  c-3.3,0-6-2.7-6-6c0-1,0.2-2,0.7-2.8c0.1-0.3,0.2-0.6,0.1-0.8c-0.1-0.3-0.3-0.5-0.6-0.6C27.9,10.2,27,8.9,27,7.5  c0-0.7,0.2-1.3,0.6-1.9c0.2-0.3,0.2-0.7,0.1-1s-0.5-0.5-0.8-0.6C26.3,4,25.6,4,25,4z M38,4c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2  S39.1,4,38,4z M36.5,12c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S37.3,12,36.5,12z M21.5,15c0.8,0,1.5,0.7,1.5,1.5  c0,0.8-0.7,1.5-1.5,1.5S20,17.3,20,16.5C20,15.7,20.7,15,21.5,15z M45,15c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1s1-0.4,1-1  C46,15.4,45.6,15,45,15z M15,20c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S13.3,20,15,20z M24.5,24c0.8,0,1.5,0.7,1.5,1.5  S25.3,27,24.5,27S23,26.3,23,25.5S23.7,24,24.5,24z M17,31c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S15.9,31,17,31z M30.5,32  c1.4,0,2.5,1.1,2.5,2.5S31.9,37,30.5,37S28,35.9,28,34.5S29.1,32,30.5,32z"></path>
                </g>
            </svg>`;
    } else {
        cookieBtn.classList.add('cc-animate');
        cookieBtn.innerHTML = 'Settings for cookies ...';
    }
}

const debouncedCookieBtnUpdate = debounce(updateCookieBtn, 250);
/********************************************************************************
 * EMAIL RECEIPT: Form Handling for Receipt Email Page
 *  - handleEmailReceiptForm: Validates, persists email opt-in via cookie,
 *    posts to AJAX endpoint & manages success/error UI states
 ********************************************************************************/

// Handle sending the email receipt form
function handleEmailReceiptForm() {
    const emailReceiptForm = document.getElementById('email-receipt-form');
    const formContainer = document.getElementById('email-form-container');
    const successPage = document.getElementById('email-submit-success');
    const qrError = document.getElementById('error-qr-code');

    const errorMsg = emailReceiptForm.querySelector('.error-message');
    const emailInput = emailReceiptForm.querySelector('#email_address');
    const saveEmail = emailReceiptForm.querySelector('#save_email');
    const submitBtn = emailReceiptForm.querySelector('#send-email-receipt');
    const loader = document.querySelector('.loading-message');

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

    const savedEmail = getCookie('mbhpc_receipt_email');

    let uuid = '';

    // Only allow users into the page if the URL contains the UUID parameter.
    if (window.location.search.includes('?uuid=')) {
        const params = new URLSearchParams(window.location.search);

        if (!uuidRegex.test(params.get('uuid'))) {
            uuid = '';
        } else {
            uuid = params.get('uuid');
        }
    }

    // If there is no UUID, redirect the user to the QR Code error screen
    if (!uuid) {
        formContainer.classList.add('hidden');
        qrError.classList.remove('hidden');
    }

    // If the user has a cookie for mbhpc_receipt_email, get the email and add it to the input field preemptively.
    // By default, if there's a save email, enabled the save email functionality
    if (savedEmail) {
        emailInput.value = getCookie('mbhpc_receipt_email');
        saveEmail.checked = true;
    }

    // Helper function to show the error message underneath the email input
    showError = () => {
        errorMsg.classList.remove('hidden');
        emailInput.classList.add('error');
        formContainer.classList.remove('loader-active');
        loader.classList.remove('show');
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Send Receipt';
    };

    // Validates the email in the input on form submit
    validateEmail = () => {
        errorMsg.classList.add('hidden');
        emailInput.classList.remove('error');

        if (!emailInput.value || !emailRegex.test(emailInput.value)) {
            showError();
            return false;
        } else {
            errorMsg.classList.add('hidden');
            emailInput.classList.remove('error');
            return true;
        }
    };

    emailReceiptForm.addEventListener('submit', (e) => {
        e.preventDefault();

        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Sending...';
        formContainer.classList.add('loader-active');
        loader.classList.add('show');
        errorMsg.classList.add('hidden');

        let emailCheck = validateEmail();

        if (emailCheck) {
            const formData = new FormData(emailReceiptForm);

            formData.append('receipt_uuid', uuid);
            formData.append('action', 'send_braze_receipt');

            // If the user enables the 'save_email' function, make sure to set the cookie.
            if (formData.get('save_email') === 'on') {
                setCookie('mbhpc_receipt_email', formData.get('email_address'), 365);
            } else {
                // If the save email function is not enabled, and there is a cookie in the browser to save it, remove the cookie.
                if (savedEmail) {
                    document.cookie = 'mbhpc_receipt_email=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                }
            }

            // AJAX query to send the data to Braze
            fetch(pacejax.ajax_url, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    // Adding a small delay to the success/fail checks
                    // To prevent loading screen flashing on submit
                    if (data.success === true) {
                        setTimeout(() => {
                            formContainer.classList.remove('loader-active');
                            loader.classList.remove('show');

                            // Show the user the Thank You screen if the submit is successful.
                            formContainer.classList.add('hidden');
                            successPage.classList.remove('hidden');
                        }, 500);
                    } else {
                        setTimeout(() => {
                            formContainer.classList.remove('loader-active');
                            loader.classList.remove('show');

                            // If not, send them to the error screen.
                            formContainer.classList.add('hidden');
                            qrError.classList.remove('hidden');
                        }, 500);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });

            submitBtn.disabled = false;
        }
    });
}

/********************************************************************************
 * APP INIT: DOMContentLoaded Root Initializer
 *  - Conditional initialization based on page templates & existing nodes
 *  - Wires up: menus, modals, sliders, cookie consent, hero controls, image
 *    groups click proxy, hero tabs state, and carousel/video behaviors
 ********************************************************************************/

document.addEventListener('DOMContentLoaded', () => {
    const consentBanner = document.getElementById('dr_cookie_banner_container');
    const revokeBtn = document.querySelectorAll('.cc-revoke');
    const documentBody = document.querySelector('body');
    const googleMap = document.getElementById('ev-charging-map');

    initHourlyPricing();

    // Add body class if sweepstakes banner is present
    if (document.getElementById('header-sweepstakes-banner')) {
        documentBody.classList.add('has-sweepstakes-banner');
    }

    if (documentBody.classList.contains('page-template-page-email-receipt-form')) {
        handleEmailReceiptForm();
    } else {
        handleMenuResize();
        window.addEventListener('resize', debounce(handleMenuResize, 250));
    }

    if (document.getElementById('our-partners')) {
        initSplide();
    }

    if (document.getElementById('contact-modal')) {
        initModal();
    }

    if (!getCookie('cookieconsent_status')) {
        consentBanner.classList.remove('cc-invisible');
        consentBanner.style.display = '';
        initCookieNotice(consentBanner);
    } else {
        consentBanner.style.display = 'none';
    }

    updateCookieBtn();
    window.addEventListener('resize', debouncedCookieBtnUpdate);

    if (googleMap) {
        updateBackBtn();
    }

    revokeBtn.forEach((btn) => {
        btn.addEventListener('click', () => {
            const button = btn;
            button.style.display = 'none';
            consentBanner.style.display = '';
            consentBanner.classList.remove('cc-invisible');
            initCookieNotice(consentBanner, button);
        });
    });

    // Add Pause/Play button to hero carousel and video background
    // Hero Carousel Pause/Play
    let pausePlayBtn; // Make button accessible outside block

    function addPausePlayBtn() {
        const heroCarousel = document.querySelector('.hero-carousel .splide');
        if (!heroCarousel) return;
        const autoplay = heroCarousel.splide?.Components?.Autoplay;
        if (!autoplay) return;
        const arrows = heroCarousel.querySelector('.splide__arrows');
        if (!arrows) return;

        const existingBtn = arrows.querySelector('.splide__pauseplay');
        if (existingBtn) return;

        pausePlayBtn = document.createElement('button');
        pausePlayBtn.className = 'splide__pauseplay playing';
        pausePlayBtn.type = 'button';
        pausePlayBtn.setAttribute('aria-label', 'Pause carousel');
        pausePlayBtn.textContent = 'Pause';
        arrows.prepend(pausePlayBtn);
        let isPaused = false;

        function getCurrentVideo() {
            const active = heroCarousel.querySelector('.splide__slide.is-active');
            return active ? active.querySelector('.wp-block-cover__video-background') : null;
        }

        function updateBtn() {
            const video = getCurrentVideo();
            if (video && isPaused && !video.paused) video.pause();
            pausePlayBtn.textContent = isPaused ? 'Play' : 'Pause';
            pausePlayBtn.setAttribute('aria-label', isPaused ? 'Play carousel' : 'Pause carousel');
            pausePlayBtn.classList.toggle('paused', isPaused);
            pausePlayBtn.classList.toggle('playing', !isPaused);
        }

        pausePlayBtn.addEventListener('click', () => {
            const video = getCurrentVideo();
            isPaused = !isPaused;
            if (isPaused) {
                autoplay.pause();
                if (video) video.pause();
            } else {
                autoplay.play();
                if (video) video.play().catch(() => {});
            }
            updateBtn();
        });

        const slides = heroCarousel.querySelector('.splide__list');
        if (slides) {
            new MutationObserver(updateBtn).observe(slides, {
                attributes: true,
                subtree: true,
                attributeFilter: ['class'],
            });
        }

        setTimeout(updateBtn, 200);
    }

    addPausePlayBtn();
    window.addEventListener('resize', addPausePlayBtn);

    const imageCarousel = document.querySelector('.image-carousel .splide'); // (CAROUSEL) Image carousel arrow offset logic
    if (imageCarousel) {
        const slideList = imageCarousel.querySelector('.splide__list');
        const arrows = imageCarousel.querySelector('.splide__arrows');

        function updateArrowsOffset() {
            const slideTexts = imageCarousel.querySelectorAll(
                '.splide__slide:not(.splide__slide--clone) .image-carousel-slide-text'
            );
            imageCarousel.style.removeProperty('--image-carousel-text-min-height');
            const textMinHeight = Math.max(
                0,
                ...Array.from(slideTexts, (text) => text.getBoundingClientRect().height)
            );
            imageCarousel.style.setProperty('--image-carousel-text-min-height', `${textMinHeight}px`);

            const activeSlide = imageCarousel.querySelector('.splide__slide.is-active:not(.splide__slide--clone)');
            const text = activeSlide?.querySelector('.image-carousel-slide-text');
            if (!text || !arrows) return;

            const textRect = text.getBoundingClientRect();
            const carouselRect = imageCarousel.getBoundingClientRect();
            const offset = carouselRect.bottom - textRect.top + 40;
            imageCarousel.style.setProperty('--image-carousel-arrows-bottom', `${offset}px`);
        }

        // Initial call
        updateArrowsOffset();

        // Update on window resize
        window.addEventListener('resize', updateArrowsOffset);

        if (slideList) {
            new MutationObserver(updateArrowsOffset).observe(slideList, {
                attributes: true,
                subtree: true,
                attributeFilter: ['class'],
            });
        }
    }

    const imageGroups = document.querySelectorAll('.columns-image-groups .wp-block-column'); // (INTERACTION) Make entire image act as link
    if (imageGroups.length === 0) return;
    imageGroups.forEach((column) => {
        const image = column.querySelector('.wp-block-image img');
        const button = column.querySelector('.wp-block-button__link');
        if (image && button) {
            image.style.cursor = 'pointer';
            image.addEventListener('click', () => {
                button.click();
            });
        }
    });

    document.querySelectorAll('.hero-tabs .nav-tabs .nav-link').forEach((link) => {
        // (UI STATE) Hero tabs active state adjustments
        link.addEventListener('click', () => {
            document.querySelectorAll('.hero-tabs .nav-tabs .nav-item').forEach((item) => {
                item.classList.remove('nav-item-active');
            });
            const activeLink = document.querySelector('.hero-tabs .nav-tabs .nav-link.active');
            if (activeLink && activeLink.parentElement.classList.contains('nav-item')) {
                activeLink.parentElement.classList.add('nav-item-active');
            }
        });
    });

    // Set initial state on DOMContentLoaded
    document.querySelectorAll('.hero-tabs .nav-tabs .nav-link.active').forEach((activeLink) => {
        // (UI STATE) Initial hero tab state
        if (activeLink.parentElement.classList.contains('nav-item')) {
            activeLink.parentElement.classList.add('nav-item-active');
        }
    });
});

/********************************************************************************
 * ACCESSIBILITY ENHANCEMENTS
 *  - wrapPostTermsList: Wraps taxonomy terms for layout semantics
 *  - addAriaLabelledByToThumbnails: Adds aria-label to featured image links
 *  - fixAccordionAnchorRoles: Ensures anchors act as buttons (role=button)
 ********************************************************************************/

// Wrap Post Terms in a Flex Div
function wrapPostTermsList() {
    document.querySelectorAll('.wp-block-post-terms').forEach((termsDiv) => {
        const prefixSpan = termsDiv.querySelector('.wp-block-post-terms__prefix');
        if (prefixSpan && !termsDiv.querySelector('.wp-block-post-terms-list')) {
            const listDiv = document.createElement('div');
            listDiv.className = 'wp-block-post-terms-list';

            let node = prefixSpan.nextSibling;
            const nodesToMove = [];
            while (node) {
                if (node.nodeType === 1 && node.classList.contains('wp-block-post-terms-list')) break;
                nodesToMove.push(node);
                node = node.nextSibling;
            }
            nodesToMove.forEach((n) => listDiv.appendChild(n));
            prefixSpan.parentNode.insertBefore(listDiv, prefixSpan.nextSibling);
        }
    });
}

// Adding aria-labelledby to Query Loop thumbnails links for accessibility
function addAriaLabelledByToThumbnails() {
    document.querySelectorAll('.wp-block-query ul li').forEach((li) => {
        const link = li.querySelector('figure.wp-block-post-featured-image a');
        const postTitle = li.querySelector('.wp-block-post-title');
        const postExcerpt = li.querySelector('.wp-block-post-excerpt__excerpt');
        const label =
            (postTitle ? postTitle.textContent.trim() : '') || (postExcerpt ? postExcerpt.textContent.trim() : '');
        if (link && label) link.setAttribute('aria-label', label);
    });
}

document.addEventListener('DOMContentLoaded', wrapPostTermsList); // (A11Y) Structure post terms
document.addEventListener('DOMContentLoaded', addAriaLabelledByToThumbnails); // (A11Y) Label thumbnails early
setTimeout(addAriaLabelledByToThumbnails, 1000); // (A11Y) Retry after potential async loads
window.addEventListener('load', addAriaLabelledByToThumbnails); // (A11Y) Final assurance after full load

// Fix accordion anchor roles for accessibility
function fixAccordionAnchorRoles() {
    const accordionDivs = document.querySelectorAll('.wp-block-pacecore-blocks-accordion');

    accordionDivs.forEach((accordionDiv) => {
        const anchorTags = accordionDiv.querySelectorAll('a');

        anchorTags.forEach((anchor) => {
            anchor.setAttribute('role', 'button');
        });
    });
}

document.addEventListener('DOMContentLoaded', fixAccordionAnchorRoles);     // (A11Y) Accordion anchor role normalization

// Fix GDPR banner padding issue when banner is position: fixed
function fixGdprBannerPadding() {
    const footer = document.getElementsByTagName('footer')[0];
    const banner = document.getElementById('dr_cookie_banner_container');

    if (footer && banner) {
        const bannerStyle = window.getComputedStyle(banner);
        if (bannerStyle.position === 'fixed' && bannerStyle.bottom === '0px') {
            footer.style.paddingBottom = footer.getAttribute('data-original-padding-bottom') || '';
        }
    }
}

// Handle GDPR banner focus management to prevent tab trapping
function handleGdprBannerFocus() {
    const banner = document.getElementById('dr_cookie_banner_container');
    if (!banner) return;

    const btns = banner.querySelectorAll('li[role="button"], a[role="button"]');
    btns.forEach(btn => btn.setAttribute('tabindex', '0'));

    const headerLogo = document.querySelector('.site-header-logo');
    const lastBtn = btns[btns.length - 1];

    // Helper to hide banner and focus Header Logo
    function hideBannerAndFocusHeaderLogo() {
    if (headerLogo) headerLogo.focus();
    banner.classList.add('dr-cookie-banner-hidden');
    }

    // Tab forward from lastBtn to headerLogo
    if (lastBtn) {
    lastBtn.addEventListener('keydown', event => {
        if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        hideBannerAndFocusHeaderLogo();
        }
    });
    }

    // Tab backward from headerLogo to lastBtn
    if (headerLogo && lastBtn) {
    headerLogo.addEventListener('keydown', event => {
        if (event.key === 'Tab' && event.shiftKey) {
        event.preventDefault();
        banner.classList.remove('dr-cookie-banner-hidden');
        lastBtn.focus();
        }
    });
    }

    // Enter key for dismissal buttons
    ['.cc-deny', '.cc-allow'].forEach(selector => {
        const btn = banner.querySelector(selector);
        if (btn) {
            btn.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    btn.click();
                    // Use setTimeout to ensure the click event completes before focus management
                    setTimeout(() => {
                        hideBannerAndFocusHeaderLogo();
                    }, 0);
                }
            });
        }
    });
}

window.addEventListener('load', function () {
    setTimeout(fixGdprBannerPadding, 100);
    setTimeout(handleGdprBannerFocus, 100);
});
